/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostPressKitBatchDownloadRequestBody
 */
export interface PostPressKitBatchDownloadRequestBody {
    /**
     * Press Kit Logo の UUID の配列（ない場合は空の配列）
     * @type {Array<string>}
     * @memberof PostPressKitBatchDownloadRequestBody
     */
    logos: Array<string>;
    /**
     * Press Kit Image の UUID の配列（ない場合は空の配列）
     * @type {Array<string>}
     * @memberof PostPressKitBatchDownloadRequestBody
     */
    images: Array<string>;
    /**
     * Press Kit Guideline File の UUID の配列（ない場合は空の配列）
     * @type {Array<string>}
     * @memberof PostPressKitBatchDownloadRequestBody
     */
    guidelineFiles: Array<string>;
    /**
     * Press Kit Documents の UUID の配列（ない場合は空の配列）
     * @type {Array<string>}
     * @memberof PostPressKitBatchDownloadRequestBody
     */
    documents: Array<string>;
    /**
     * Press Kit Profiles の UUID の配列（ない場合は空の配列）
     * @type {Array<string>}
     * @memberof PostPressKitBatchDownloadRequestBody
     */
    profiles: Array<string>;
}

export function PostPressKitBatchDownloadRequestBodyFromJSON(json: any): PostPressKitBatchDownloadRequestBody {
    return PostPressKitBatchDownloadRequestBodyFromJSONTyped(json, false);
}

export function PostPressKitBatchDownloadRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostPressKitBatchDownloadRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'logos': json['logos'],
        'images': json['images'],
        'guidelineFiles': json['guideline_files'],
        'documents': json['documents'],
        'profiles': json['profiles'],
    };
}

export function PostPressKitBatchDownloadRequestBodyToJSON(value?: PostPressKitBatchDownloadRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'logos': value.logos,
        'images': value.images,
        'guideline_files': value.guidelineFiles,
        'documents': value.documents,
        'profiles': value.profiles,
    };
}

